import { type CSSProperties } from 'react';

interface ColorPaletteAccessibleProps {
    fontColor: CSSProperties['color'];
    backgroundColor: CSSProperties['background'];
    description: string;
    compliance: string;
}

export const ColorPaletteAccessible = ({
    fontColor,
    backgroundColor,
    description,
    compliance,
}: ColorPaletteAccessibleProps) => (
    <div
        className="sds_color-palette-accessible__container__column"
        style={{ background: backgroundColor }}
    >
        <div className="sds_color-palette-accessible__compliance">{compliance}</div>
        <div style={{ color: fontColor }}>{description}</div>
    </div>
);
